module.exports = __webpack_public_path__ + "static/img/waving-hand.93172a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/waving-hand.png
// module id = VE8+
// module chunks = 1